import * as Dialog from '@radix-ui/react-dialog';

import { Button } from '@/components/Button/Button';

import styles from './ResetAppletDialog.module.css';

interface ResetAppletDialogProps {
  /** What the control resets, e.g. "notebook" — used in the copy. */
  noun: string;
  onConfirm: () => void;
  onOpenChange: (nextOpen: boolean) => void;
  open: boolean;
}

// Reset discards the student's in-browser work for this applet and reloads the
// original, so the confirmation says so plainly. Follows the repo's destructive
// -confirm shape (see ResetConversationDialog): a Radix Dialog with a
// role="alert" warning, rather than pulling in another Radix package.
export function ResetAppletDialog({
  noun,
  onConfirm,
  onOpenChange,
  open,
}: ResetAppletDialogProps) {
  return (
    <Dialog.Root onOpenChange={onOpenChange} open={open}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={styles.content}>
          <div>
            <Dialog.Title className={styles.title}>Reset this {noun}?</Dialog.Title>
            <Dialog.Description asChild>
              <p className={styles.description}>
                This restores the original {noun} that was provided to you.
              </p>
            </Dialog.Description>
          </div>

          <div className={styles.warning} role="alert">
            <strong>This can't be undone.</strong>
            <span>Any changes you've made in this {noun} will be discarded.</span>
          </div>

          <div className={styles.footer}>
            <Dialog.Close asChild>
              <Button variant="secondary">Keep my work</Button>
            </Dialog.Close>
            <Button destructive onClick={onConfirm}>
              Reset {noun}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
